import { createContext, useContext, useEffect, useState, useRef } from "react";
import { auth } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { axiosWithAuth } from "../services/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [emailVerified, setEmailVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        setEmailVerified(Boolean(user.emailVerified));
        await checkEmailStatus();
      } else {
        setCurrentUser(null);
        setEmailVerified(false);
      }
      setLoading(false);
    });

    return () => {
      isMountedRef.current = false;
      unsubscribe();
    };
  }, []);

  const checkEmailStatus = async () => {
    if (!auth.currentUser) return;
    try {

      await auth.currentUser.reload();

      const api = await axiosWithAuth();
      const { data } = await api.get("/auth/status");

      if (!isMountedRef.current) return;

      setCurrentUser(auth.currentUser);
      setEmailVerified(Boolean(data.email_verified));
      return data.email_verified;
    } catch (err) {
      //console.error("Erro ao consultar backend (checkEmailStatus):", err);
      return false;
    }
  };

  const confirmClicked = async () => {
    await checkEmailStatus();
  };

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        emailVerified,
        refreshUser: checkEmailStatus,
        confirmClicked,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};
